/**
 * Role Display Name Mapper
 *
 * Maps internal role names to user-friendly Arabic display names.
 * This follows the clean architecture principle of separating business logic
 * from presentation concerns.
 */

export interface RoleDisplayMapping {
  [key: string]: string;
}

/**
 * Default role display mappings for Arabic interface
 * Maps internal role names to user-friendly Arabic display names
 */
export const ROLE_DISPLAY_MAPPINGS: RoleDisplayMapping = {
  'admin': 'مدير',
  'accountal_manager': 'مدير محاسبي',
  'sales_superphaser': 'مشرف مبيعات',
  'marketer': 'مسوق',
  'service_provider': 'مزود خدمة',
  'store_manager': 'مدير متجر',
  'cashier': 'أمين صندوق',
  'inventory_manager': 'مدير مخزون'
};

/**
 * Gets the user-friendly display name for a role
 *
 * @param roleName - The internal role name
 * @param customMappings - Optional custom mappings to override defaults
 * @returns The display name for the role, or the original name if no mapping exists
 */
export const getRoleDisplayName = (
  roleName: string,
  customMappings?: RoleDisplayMapping
): string => {
  const mappings = {...ROLE_DISPLAY_MAPPINGS, ...customMappings};
  return mappings[roleName] || roleName;
};

/**
 * Gets the fallback display name for unknown roles
 */
export const getUnknownRoleDisplayName = (): string => {
  return 'دور غير معروف';
};
